

import Course from "./interfaces/course";
import Education from "./interfaces/education";
import { Experience, ExperienceFuction } from "./interfaces/experience";
import { ImageProject, LinkProject, Project } from "./interfaces/projetct";
import Section from "./interfaces/section";
import Skill from "./interfaces/skill";

export const sections = [
    { id: 1, name: "Inicio", description: "" },
    { id: 2, name: "Sobre Mim", description: "" },
    { id: 3, name: "Habilidades", description: "" },
    { id: 4, name: "Experiência", description: "" },
    { id: 5, name: "Acadêmico", description: "" },
    { id: 6, name: "Cursos/Certificados", description: "" },
    { id: 7, name: "Portfólio", description: "" },
] as Section[];

export const hardSkills = [
    { name: "C# .NET", rating: 5 },
    { name: "Java", rating: 2 },
    { name: "NodeJs", rating: 4 },
    { name: "Javascript/Typescript", rating: 4 },
    { name: "NextJs", rating: 4 },
    { name: "ReactJs", rating: 4 },
    { name: "SQL", rating: 5 },
    { name: "Firebase", rating: 2 },
    { name: "MongoDb", rating: 3 },
    { name: "Elastic Search", rating: 3 },
    { name: "Oracle", rating: 4 },
    { name: "API Restfull", rating: 5 },
    { name: "Git", rating: 4 },
    { name: "Mensageria (RabbitMq, Service Bus)", rating: 4 },
    { name: "Docker", rating: 2 },
    { name: "CI/CD", rating: 4 },
] as Skill[];

export const softSkills = [
    { name: "Colaboração", rating: 4 },
    { name: "Comunicação", rating: 5 },
    { name: "Inteligência Emocional", rating: 4 },
    { name: "Organização", rating: 3 },
    { name: "Resiliência", rating: 4 },
    { name: "Resolução de Problemas", rating: 5 },
] as Skill[];

export const experiences = [
    {
        companyName: "ePharma",
        corporateName: "Epharma PBM do Brasil S.A.",
        office: "Desenvolvedor Fullstack Pleno",
        startDate: new Date("07/03/2023"),
        endDate: new Date("08/05/2026"),
        mainTechnologies: ["C# .NET (8 e >)", "Oracle", "Sql Server", "ServiceBus", "NextJs", "ReactJs", "TypeScript", "Micro Serviço", "DevOps"],
        functions: [
            { description: "Criação de API's Rest para integração com sistemas externos" },
            { description: "Criação de RPA's para integração e automatização de processos" },
            { description: "Criação de webhooks de uso externo" },
            { description: "Gerenciamento de filas de mensageria (ServiceBus)" },
            { description: "Utilização de ORM's para acesso aos dados (Dapper e Entity Framework)" },
            { description: "Criação de testes automatizados (FluentAssertions, Faker e Moq)" },
            { description: "Manutenção de packages e procedures (Oracle)" },
            { description: "Gerenciamento de código (Git)" },
            { description: "Atualização de bibliotecas utilizadas como .NET e pacotes npm" },
            { description: "Code review de outros desenvolvedores" },
            { description: "Configuração de esteiras de deploy (CI/CD) no Azure DevOps" },
            { description: "Reuniões de definição com clientes internacionais" },
            { description: "Gerenciamento de crise" },
    ] as ExperienceFuction[] },
    {
        companyName: "Semantix",
        corporateName: "Semantix Tecnologia em Sistema de Informação",
        office: "Desenvolvedor Fullstack Jr/Pleno",
        //formato: mm/DD/yyyy
        startDate: new Date("08/02/2021"),
        endDate: new Date("07/03/2023"),
        mainTechnologies: ["C# .NET", "ReactJs", "React Native", "TypeScript", "NodeJs", "Graphql", "Redis", "Postgresql", "SQL Server", "MySql", "RabbitMQ", "ElasticSearch"],
        functions: [
            { description: "Criação de novas funcionalidades para o ecommerce SmartesSales" },
            { description: "Criação de APIs de integração com sistemas externos" },
            { description: "Criação de RPAs para integração e automatização de processos" },
            { description: "Desenvolvimento e implantação de novas funcionalidades para produtos de chatbot" },
            { description: "Gerenciamento de filas de mensageria" },
            { description: "Configuração de esteiras de deploy (CI/CD) no GitLab" },
            { description: "Treinamento de funcionários/clientes" },
            { description: "Gerenciamento de crise" },
        ] as ExperienceFuction[] },
        {
        companyName: "A.Telecom",
        corporateName: "A.Telecom Teleinformática",
        office: "Desenvolvedor Fullstack Jr",
        startDate: new Date("10/05/2020"),
        endDate: new Date("07/30/2021"),
        mainTechnologies: ["C# .NET", "ReactJs", "Typescript", "SQL Server", "MySql"],
        functions: [
            { description: "Criação de novos produtos" },
            { description: "Integração com APIs internas e externas" },
            { description: "Criação de novas funcionalidades para sistemas de contact center e telefonia" },
            { description: "Criação e gestão de querys e de estruturas de banco de dados" },
    ] as ExperienceFuction[] },
        {
        companyName: "ORGM",
        corporateName: "ORGM Software de Gestão",
        office: "Estágio/Desenvolvedor Jr",
        startDate: new Date("10/01/2017"),
        endDate: new Date("01/03/2020"),
        mainTechnologies: ["VBA", "C#", "JavaScript", "SQL Server"],
        functions: [
            { description: "Desenvolvimento de funcionalidades para sistema ERP" },
            { description: "Visita a clientes para levantamento de requisitos" },
            { description: "Modelagem de banco de dados" },
    ] as ExperienceFuction[] },
 ] as Experience[];

 export const educations = [
    {
        name: "Tecnólogo em Análise e Desenvolvimento de Software",
        schoolName: "FIAP",
        schoolNameFull: "Faculdade de Informática e Administração Paulista",
        startDate: new Date("01/01/2016"),
        endDate: new Date("12/01/2017"),
        status: "Concluído",
        achievements : ["Medalhista de prata no Challenge Natura, Festival NEXT"]
    },
    {
        name: "Técnico em informática",
        schoolName: "ETEC",
        schoolNameFull: "Juscelino Kubitschek de Oliveira",
        startDate: new Date("01/01/2014"),
        endDate: new Date("06/01/2015"),
        status: "Concluído"
    }
 ] as Education[];

 export const courses = [
    { name: "Certificado de Qualificação Profissional em Desenvolvimento de Aplicativos Móveis", schoolName: "FIAP", conclusionYear: "2017" },
    { name: "Certificado de Qualificação Profissional em Empreendedorismo Digital e Gestão de Tecnologias da Informação", schoolName: "FIAP", conclusionYear: "2017" },
    { name: "Elastic Essentials", schoolName: "Semantix Academy", conclusionYear: "2021" },
    { name: "Redis Básico", schoolName: "Semantix Academy", conclusionYear: "2021" },
    { name: "MongoDB Básico", schoolName: "Semantix Academy", conclusionYear: "2021" },
 ] as Course[];

 export const projects = [
    {
        name: "Micro-serviço System",
        description: "Sistema baseado em micro serviços utilizando conceitos de service discovery, balanceamento de carga baseado no algoritmo Round Robin, logs centralizados, healthcheck dos serviços baseado no Eureka e etc.",
        mainFuctions: [
            "Micro API's CRUD utilizando Entity Framework para acesso a dados",
            "Pattern Service Registry e Service Discovery",
            "API com self registry",
            "Pattern Log centralizado utilizando RabbitMQ",
            "Balanceamento de carga com algoritmo Round Robin",
            "Validação da disponibilidade do serviço utilizando heart beats (baseado no Eureka)",
            "Centralização em uma lib das 'funcionalidades' compartilhadas entre os serviços",
            "Middleware de autenticação",
            "Middleware de negócio",
            "Diferentes níveis de acesso (usuários)",
            "Autenticação utilizando schema RSA (chave pública e chave privada)"
        ],
        mainTechnologies: ["C# .NET", "Entity Framework", "MySql", "NodeJs", "MongoDb", "Memory Cache", "Algoritmo Round Robin"],
        images: [
            { name: "api-getaway-service-discovery.png", label: "Lógica de discovery de um serviço no API Getaway" },
            { name: "api-getaway-service-load-balance.png", label: "Lógica de balanceamento de carga de um serviço no API Getaway utilizando Round Robin" },
            { name: "service-registry-heart-beat.png", label: "Lógica healthcheck do Service Registry baseado no Eureka" },
            { name: "service-registry-heart-beat.png", label: "Acesso aos dados do Service Registry (MongoDb)" },
            { name: "lib-error-midleware.png", label: "Middleware de erro (centralizado na LIB)" },
            { name: "lib-error-service.png", label: "Lógica de envio do erro ao serviço de mensageria (RabbitMQ)" },
            { name: "simple-api-overview.png", label: "Estrutura de um micro serviço" },
            { name: "simple-api-dockerfile.png", label: "Dockerfile um micro serviço" },
            { name: "simple-api-compose-yaml.png", label: "Compose.yaml de um micro serviço" },
            { name: "simple-api-init-scripts.png", label: "Script de criação de tabelas de um micro serviço" },
            { name: "auth-service-application.png", label: "Lógica RSA pra geração de token de autenticação" },
        ] as ImageProject[],
        links: [
            { name: "Repositórios", url: "https://github.com/orgs/orcamentaria-microservice/repositories", type: "git" },
        ] as LinkProject[],
        subDirectory: "micro-services"
    },
    {
        name: "Orçamentaria",
        description: "Sistema web responsivo que tem como objetivo a emissão de orçamentos para pinturas imobiliarias e industriais.",
        mainFuctions: [
            "CRUD de Pessoas (cliente, fornecedor e funcionário)",
            "CRUD de Materiais",
            "CRUD de Equipamentos",
            "CRUD de Custo",
            "CRUD de Carta de Cobertura",
            "CRUD e Emissão de orçamento em PDF"
        ],
        mainTechnologies: ["C# .NET", "Dapper", "ReactJs", "Javascript", "MySql", "Bootstrap"],
        images: [
            { name: "pessoas.png", label: "Cadastro cliente" },
            { name: "funcionario.png", label: "Cadastro funcionário" },
            { name: "material.png", label: "Tela material" },
            { name: "carta_cobertura.png", label: "Cadastro de carta de cobertura" },
            { name: "carta_cobertura_2.png", label: "Carta cobertura importada apartir do excel" },
            { name: "carta_cobertura_3.png", label: "Edição/Exclusão de carta de cobertura" },
            { name: "orcamento.png", label: "Cadastro de orçamento" },
            { name: "orcamento_2.png", label: "Adição de funcionário ao orçamento e seu custos" },
            { name: "orcamento_3.png", label: "Totais do orçamento" },
            { name: "orcamento_4.png", label: "PDF do orçamento gerado" },
        ] as ImageProject[],
        links: [
            { name: "Repositório frontend", url: "https://github.com/Orcamentaria/orcamentaria-client", type: "git" },
            { name: "Repositório backend", url: "https://github.com/Orcamentaria/orcamentaria-server", type: "git" },
            { name: "Repositório diagramas", url: "https://github.com/Orcamentaria/orcamentaria-doc", type: "git" },
        ] as LinkProject[],
        subDirectory: "orcamentaria"
    },
    {
        name: "Cronog",
        description: "Aplicativo que te ajuda conquistar seus objetivos. Quer criar uma rotina de leitura, musculação, alimentação? Cadastre um novo Cronog, definindo icone e cor personalizados. Não se preocupe, você receberá uma notificação no horário configurado para não esquecer do seu objetivo.",
        mainFuctions: [
            "Login",
            "Cadastro de rotinas personalizadas",
            "Lembrete por notificação da execução da rotina",
            "Criação de tarefas que permitirão que você acompanhe seu progresso",
            "Reordenção arrasta e solta das rotinas cadastradas",
        ],
        mainTechnologies: ["NodeJs", "ReactJs", "Typescript", "CapacitorJS", "Firebase", "Yup", "Storybook"],
        images: [
            { name: "login.png", label: "Login app" },
            { name: "cronog.png", label: "Cadastro de um Cronog" },
            { name: "cronog-cor.png", label: "Seleção da cor do Cronog" },
            { name: "cronog-icone.png", label: "Seleção do icone do Cronog" },
            { name: "home.png", label: "Tela de exibição dos Cronogs cadastrados" },
            { name: "notificacao.png", label: "Notifição de lembrete" },
            { name: "nova-tarefa.png", label: "Cadastro de uma nova tarefa" },
            { name: "tarefas.png", label: "Tela de exibição das tarefas do Cronog" },
        ] as ImageProject[],
        links: [
            { name: "Repositório frontend", url: "https://github.com/Cronog/cronog-client", type: "git" },
            { name: "Repositório backend", url: "https://github.com/Cronog/cronog-server", type: "git" },
            { name: "Download APK", url: "assetsProjects/cronog/Cronog.zip", type: "download" },
        ] as LinkProject[],
        subDirectory: "cronog"
    },
    {
        name: "Aponta",
        description: "Sistema web responsivo que te ajuda a ter o controle sobre o tempo gasto em tarefas. Nele você cadastra tarefas e começa a apontar.",
        mainFuctions: [
            "Login",
            "Cadastro de tarefas",
            "Apontamento de horas",
            "Histórico de apontamento",
        ],
        mainTechnologies: ["C# .NET", "Dapper", "ReactJs", "Typescript", "Bootstrap"],
        images: [
            { name: "login.png", label: "Login site" },
            { name: "home.png", label: "Tela de inicio" },
            { name: "nova-tarefa.png", label: "Cadastro de nova tarefa" },
            { name: "apontamento.png", label: "Apontando em uma tarefa" },
            { name: "historico.png", label: "Tela de exibição do histórico de apontamentos" },
        ] as ImageProject[],
        links: [
            { name: "Repositório frontend", url: "https://github.com/Aponta/aponta-client", type: "git" },
            { name: "Repositório backend", url: "https://github.com/Aponta/aponta-server", type: "git" },
            { name: "aponta.marcelo-nogueira.dev", url: "https://aponta.marcelo-nogueira.dev/login", type: "site" },
        ] as LinkProject[],
        subDirectory: "aponta"
    },
    {
        name: "Wpp-Bot",
        description: "Um completo bot para whatsapp. Crie o fluxo que desejar e ele responderá para você.",
        mainFuctions: [
            "Configuração fluxo",
            "Envio de mensagens de texto, imagens, menus e etc",
            "Envio de email avisando para caso o bot se desconecte",
            "Integração com Dialoflow para entendimento de frases",
        ],
        mainTechnologies: ["NodeJs", "ReactJs", "Typescript", "Firebase", "Dialogflow", "Nodemailer"],
        images: [
            { name: "inicio-do-fluxo.png", label: "Inicio do fluxo" },
            { name: "menu-incial.png", label: "Menu com opções" },
            { name: "sub-menu.png", label: "Sub menu com opcões" },
            { name: "imagem-fluxo.png", label: "Envio de imagem e reconhecimento de máquina" },
        ] as ImageProject[],
        links: [
            { name: "Repositório backend", url: "https://github.com/Mafealno/wpp-bot-server", type: "git" },
        ] as LinkProject[],
        subDirectory: "wpp-bot"
    },
 ] as Project[];